module.exports = function(ngModule) {
  ngModule.config(['$stateProvider', function($stateProvider) {
    $stateProvider.state('landing', {
      url: '/:type/:id',
      template: require('./landing.html'),
      controller: require('./controller.js'),
      controllerAs: 'vm',
      resolve: {
        validCheck: function($stateParams, SiteVisitApi) {
          return SiteVisitApi.checkId({type: $stateParams.type, id: $stateParams.id})
        }
      }
    });
  }]);
};
